import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faHouse,faCircleInfo,faAddressBook,faCircleQuestion} from '@fortawesome/free-solid-svg-icons'
import {faTwitter,faLinkedin,faSquareFacebook,faSquareGithub} from '@fortawesome/free-brands-svg-icons'
import { useState } from 'react'
import { Navigate, useNavigate } from "react-router-dom";
export default function Hamburg() {
  const navigate=useNavigate()
  let enlight=(idz)=>{
    for (let i = 0; i < 4; i++) {
      document.getElementsByClassName("hamitms")[i].classList='hamitms'
    }
      document.getElementById(idz).classList.add("hamactive")
  }
  let idz=[
    "house",
    "info",
    "add",
    "ques"]
  return (
    <div id='hammenu'>
      <div id='hamext'></div>
      <div className='hamburger flex' id='hamburgerid'>
        <div id='logo'></div>
        <div className='hambtnbox flex' id='hamboxid'>
          <li className='hamitms hamactive' id={idz[0]} onClick={()=>{enlight(idz[0]);navigate('/playground')}}> <FontAwesomeIcon icon={faHouse}/> Home </li>
          <li className='hamitms' id={idz[1]} onClick={()=>{enlight(idz[1]);navigate('/about')}}> <FontAwesomeIcon icon={faCircleInfo} /> About </li>
          <li className='hamitms' id={idz[2]} onClick={()=>{enlight(idz[2]);navigate('/contact')}}> <FontAwesomeIcon icon={faAddressBook} /> Contact </li>
          <li className='hamitms' id={idz[3]} onClick={()=>{enlight(idz[3]);navigate('/howto')}}> <FontAwesomeIcon icon={faCircleQuestion} /> How to </li>
        </div>
        <div className='sochead'>Share the love, follow us on:</div>
        <div className='socialbox flex'>
          <FontAwesomeIcon className='socialicon' icon={faTwitter} />
          <FontAwesomeIcon className='socialicon' icon={faSquareFacebook} />
          <FontAwesomeIcon className='socialicon' icon={faLinkedin} />
          <FontAwesomeIcon className='socialicon' icon={faSquareGithub} />
        </div>
      </div>
    </div>
  )
}
